import { useMemo } from 'react';
import { selectActiveView } from '../../selectors/view';
export function useReferenceUrl(_ref) {
  var useSelector = _ref.useSelector;
  var activeViewName = useSelector(selectActiveView);
  return useMemo(function () {
    if (typeof window === 'undefined') {
      return undefined;
    }

    var url = new URL(window.location.href);
    url.hash = "auth=".concat(activeViewName);
    return url.toString();
  }, [activeViewName]);
}